export const ItemTypes = {
  TRAIN_PANEL_SPLITTER: 'trainPanelSplitter',
  // The ItemType used when the user double-clicks to maximize or restore the TrainRunInterval
  TRAIN_RUN_INTERVAL_BAR_MAXIMIZER: 'trainRunIntervalBarMaximizer',
  TRAIN_RUN_INTERVAL_BAR_LEFT_MAXIMIZER: 'trainRunIntervalBarLeftMaximizer',
  TRAIN_RUN_INTERVAL_BAR_RIGHT_MAXIMIZER: 'trainRunIntervalBarRightMaximizer',
  TRAIN_RUN_INTERVAL_BAR_MOVER: 'trainRunIntervalBarMover',
  TRAIN_RUN_INTERVAL_BAR_LEFT_EXPANDER: 'trainRunIntervalBarLeftExpander',
  TRAIN_RUN_INTERVAL_BAR_RIGHT_EXPANDER: 'trainRunIntervalBarRightExpander'
};